<template>
  <div class="register main-login">
    <div class="register-form">
      <p class="supplement-title">微信注册信息完善</p>
      <input type="text" v-model="nickname" placeholder="请输入昵称 / 姓名" class="nickname" />
      <input type="text" v-model="username" placeholder="请输入手机号码" class="username" />
      <div class="code-box">
        <input type="text" v-model="code" placeholder="请输入验证码" class="code" />
        <button v-if="count === 0" class="code-btn" @click="getPhoneCode()">获取验证码</button>
        <button v-else class="code-btn" disabled>{{ count }}秒后重试</button>
      </div>

      <button class="register-btn" @click="register()">注 册</button>
      <div class="other">
        <a @click="goLogin()">返回登录</a>
        <a @click="showUnionid()">查看UnionID</a>
      </div>
    </div>
  </div>
</template>

<script>
import { PASSPORT_CLIENT_SERVER } from '../../config/url'
import { hasMysqlUtf8UnsupportedChar } from '../../util/validate'

export default {
  name: 'register',
  props: {
    redirectURI: String,
  },
	data() {
		return {
      openid: '',
      unionid: '',
      username: '',
      nickname: '',
      code: '',
      codeGuid: '',
      count: 0,
      countTime: null
		}
  },
  mounted() {
    const { unionid, openid, nickname, errMsg } = this.$route.query
    this.nickname = nickname
    this.unionid = unionid
    this.openid = openid

    if(errMsg) return this.$message.warning(errMsg)
  },
  methods: {
    async register() {
      if(!this.unionid || !this.openid) {
        return this.$message.warning('检查不到微信认证信息，请返回登录页重新扫码', 60)
      }
      if(
        !this.username ||
        !this.nickname ||
        !this.code
      ) {
        return this.$message.warning('信息填写不完整', 60)
      }

      if(!/^1[23456789]\d{9}$/.test(this.username)) { 
        return this.$message.warning('请输入合法的手机号')
      }

      if(
        hasMysqlUtf8UnsupportedChar(this.username) ||
        hasMysqlUtf8UnsupportedChar(this.nickname)
      ) {
        return this.$message.warning('用户名或昵称不能包含 emoji、生僻字等特殊字符', 60)
      }

      if(!this.codeGuid) {
        return this.$message.warning('请先获取验证码')
      }

      const checkCodeRet = await this.$api.account.checkcode(this.codeGuid, this.code)
      if(checkCodeRet.code !== 1) {
        this.code = ''
        this.codeGuid = ''
        return this.$message.warning(checkCodeRet.msg || '验证码错误', 60)
      }

      const bindRet = await this.$api.passport.bindWxApp({
        phone: this.username,
        unionid: this.unionid,
        openid: this.openid,
        nickname: this.nickname
      })

      if(bindRet.status !== 1) {
        return this.$message.warning(bindRet.msg || '微信绑定失败', 60)
      }

      location.href = `${PASSPORT_CLIENT_SERVER}/wx/enter?token=${bindRet.token}&redirectURI=${this.redirectURI}`
    },

    goLogin() {
      this.$router.push({ name: 'login', query: { redirectURI: this.redirectURI } })
    },

    showUnionid() {
      this.$message.warning(this.unionid || '暂无UnionID', 60)
    },

    async getPhoneCode() {
      if(!/^1[23456789]\d{9}$/.test(this.username)) {
        return this.$message.warning('请输入合法的手机号', 60)
      }

      this.count = 60
      this.countTime = setInterval(() => {
        this.count -= 1
        if(this.count === 0) {
          clearInterval(this.countTime)
          this.countTime = null
        }
      }, 1000)

      const sendSmsRet = await this.$api.account.sendSms(this.username)
      if(sendSmsRet.code !== 1 || !sendSmsRet.data || !sendSmsRet.data.PK_CodeGuid) {
        clearInterval(this.countTime)
        this.countTime = null
        this.count = 0
        return this.$message.warning(sendSmsRet.msg || '验证码发送失败', 60)
      }
      this.codeGuid = sendSmsRet.data.PK_CodeGuid
      this.$message.success('短信已发送，请注意查收')
    },
  }
}
</script>

<style lang="scss" scoped>
.register {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.supplement-title {
  font-weight: 700;
  font-size: 20px;
  color: #333;
  margin-bottom: 12px;
}
.register-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .code-box {
    width: 270px;
    display: flex;
    align-items: center;
    margin: 5px 0;

    input {
      flex: 1;
      width: auto;
      margin: 0;
    }

    .code-btn {
      width: 80px;
      margin: 0 0 0 8px;
      font-size: 11px;
      padding: 0;
    }
  }

  .other {
    width: 270px;
    font-size: 12px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    a {
      color: #666;
    }
  }
}
</style>
